<template>
  <v-dialog
    v-model="computedSnowmakingHydrantsVisibility"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card>
        <v-btn icon @click="methodToggleListView('snowmaking', 'hydrants')">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title class="hidden-sm-and-down">Hydrants</v-toolbar-title>
        <v-spacer class="hidden-sm-and-down"></v-spacer>

        <v-select
          style="margin-top: 10px"
          :items="select_mountain_items"
          v-model="select_mountain_model"
          attach
        ></v-select>
        <v-spacer class="hidden-sm-and-down"></v-spacer>
        <v-text-field
          style="margin-top: -10px"
          append-icon="search"
          single-line
          hide-details
          v-model="search"
          placeholder="Filter data"
        ></v-text-field>
        <v-spacer class="hidden-sm-and-down"></v-spacer>

        <v-menu
          v-if="
            computedAuthProfile === 'admin' ||
              computedAuthProfile === 'maintenance'
          "
          bottom
          left
        >
          <v-btn slot="activator" icon>
            <v-icon>get_app</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click.stop="methodDownloadCSV()">
              <v-list-tile-title>CSV</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              @click.stop="
                methodDownloadKML(
                  $store.state.mapLayers.snowmaking.layers.hydrants.geojson,
                  'hydrnt_num',
                  'snowmaking_hydrants.kml'
                )
              "
            >
              <v-list-tile-title>KML</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>

        <v-btn icon @click.stop="addHydrant = true">
          <v-icon>add</v-icon>
        </v-btn>
      </v-toolbar>
      <div
        style="
          background-color: black;
          padding-left: 30px;
          overflow: auto;
          -webkit-overflow-scrolling: touch;
        "
      >
        <v-data-table
          :headers="headers"
          :items="computedSnowmakingHydrantGeoJsonFeatures"
          :rows-per-page-items="rows_per_page"
          :rows-per-page-text="rows_per_page_text"
          :search="search"
          class="elevation-1"
          :loading="computedSnowmakingHydrantsLoading"
        >
          <template slot="items" slot-scope="props">
            <tr
              @click="
                methodToggleSingleLayer(
                  'snowmaking',
                  'hydrants',
                  true,
                  props.item.properties.id
                )
              "
            >
              <td>{{ props.item.properties.hydrnt_num }}</td>
              <td>{{ props.item.properties.trail_name }}</td>
              <td>{{ props.item.properties["30a"] }}</td>
              <td>{{ props.item.properties["60a"] }}</td>
              <td>{{ props.item.properties.circuit }}</td>
              <td>{{ props.item.properties.water }}</td>
              <td>{{ props.item.properties.air }}</td>
              <td>{{ props.item.properties.modified }}</td>
            </tr>
          </template>

          <!-- Alert when no results found -->
          <v-alert slot="no-results" :value="true" color="error" icon="warning"
            >Your search for "{{ search }}" found no results.</v-alert
          >
        </v-data-table>
      </div>
      <div style="flex: 1 1 auto"></div>
    </v-card>

    <!-- ADD HYDRANT -->
    <v-dialog
      v-model="addHydrant"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card>
          <v-btn
            icon
            @click="
              addHydrant = false;
              clearWatchLocation();
              methodClearForm();
              lat = null;
              lng = null;
              accuracy = null;
              altitude = null;
            "
          >
            <v-icon>close</v-icon>
          </v-btn>

          <v-toolbar-title class="hidden-sm-and-down"
            >Add Hydrant</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn
            v-if="!tracking"
            :disabled="tracking"
            color="success"
            @click="geoWatchPosition()"
            >Start GPS</v-btn
          >
          <v-btn
            v-if="tracking"
            :disabled="!tracking"
            color="error"
            @click="clearWatchLocation()"
            >Stop GPS</v-btn
          >
          <v-spacer></v-spacer>
        </v-toolbar>
        <div
          style="
            background-color: black;
            padding-left: 30px;
            overflow: auto;
            -webkit-overflow-scrolling: touch;
          "
        >
          <v-data-table
            v-if="addHydrant"
            :items="addItemBlank"
            :hide-headers="addItemHideHeaders"
            :hide-actions="addItemHideActions"
          >
            <template slot="items">
              <tr>
                <td>Latitude</td>
                <td>
                  <span v-if="!lat && tracking">Getting latitude...</span>
                  {{ lat }}
                </td>
              </tr>
              <tr>
                <td>Longitude</td>
                <td>
                  <span v-if="!lng && tracking">Getting longitude...</span>
                  {{ lng }}
                </td>
              </tr>
              <tr>
                <td>Accuracy</td>
                <td>
                  <span v-if="!accuracy && tracking">Getting accuracy...</span>
                  {{ accuracy }}
                  <span v-if="accuracy">m</span>
                </td>
              </tr>
              <tr>
                <td>Altitude</td>
                <td>
                  <span v-if="!altitude && tracking">Getting altitude...</span>
                  {{ altitude }}
                  <span v-if="altitude">m</span>
                </td>
              </tr>
              <tr>
                <td>Hydrant #</td>
                <td>
                  <v-text-field
                    name="hydrnt_num"
                    v-model="form.hydrnt_num"
                  ></v-text-field>
                </td>
              </tr>
              <tr>
                <td>Mountain</td>
                <td>
                  <v-select
                    :items="opt_mountain"
                    v-model="form.mountain"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Trail</td>
                <td>
                  <v-select
                    :items="computedTrails"
                    v-model="form.trail_name"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>30A</td>
                <td>
                  <v-select
                    :items="opt_aw3060"
                    v-model="form['30a']"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>60A</td>
                <td>
                  <v-select
                    :items="opt_aw3060"
                    v-model="form['60a']"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Water</td>
                <td>
                  <v-select :items="opt_aw3060" v-model="form.water"></v-select>
                </td>
              </tr>
              <tr>
                <td>Air</td>
                <td>
                  <v-select :items="opt_aw3060" v-model="form.air"></v-select>
                </td>
              </tr>
              <tr>
                <td>Circuit</td>
                <td>
                  <v-text-field
                    name="circuit"
                    v-model="form.circuit"
                  ></v-text-field>
                </td>
              </tr>
              <tr>
                <td>Power Source Description</td>
                <td>
                  <v-text-field
                    name="elec_maint"
                    v-model="form.elec_maint"
                  ></v-text-field>
                </td>
              </tr>
              <tr>
                <td>Tower Type</td>
                <td>
                  <v-select
                    :items="opt_tower_type"
                    v-model="form.tower_type"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Comments</td>
                <td>
                  <v-textarea
                    name="hyd_notes"
                    v-model="form.notes"
                  ></v-textarea>
                </td>
              </tr>
            </template>
            <template slot="footer">
              <tr>
                <td colspan="100%">
                  <v-spacer class="hidden-sm-and-down"></v-spacer>
                  <v-btn
                    @click.stop="
                      methodAddSnowmakingHydrantGeoJson({
                        hydrnt_num: form.hydrnt_num,
                        mountain: form.mountain,
                        trail_name: form.trail_name,
                        '30a': form['30a'],
                        '60a': form['60a'],
                        water: form.water,
                        air: form.air,
                        circuit: form.circuit,
                        elec_maint: form.elec_maint,
                        notes: form.notes,
                        modified: new Date(Date.now()).toISOString()
                      });
                      addHydrant = false;
                    "
                    color="success"
                    >Save</v-btn
                  >
                  <v-spacer class="hidden-sm-and-down"></v-spacer>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import { parse } from "json2csv";

export default {
  data() {
    return {
      addHydrant: false,
      addItemBlank: [""],
      addItemHideHeaders: true,
      addItemHideActions: true,
      form: {
        hydrnt_num: null,
        mountain: null,
        trail_name: null,
        "30a": null,
        "60a": null,
        water: null,
        air: null,
        circuit: null,
        elec_maint: null,
        notes: null,
        edit_by: null,
        tower_type: null
      },
      rows_per_page: [
        10,
        25,
        50,
        {
          text: "All",
          value: -1
        }
      ],
      rows_per_page_text: "Per page:",
      opt_aw3060: [{ text: "1" }, { text: "2" }, { text: "3" }, { text: "4" }],
      opt_tower_type: [
        { text: "N/A", value: 0 },
        { text: 1 },
        { text: 2 },
        { text: 3 }
      ],
      opt_mountain: [{ text: "Whistler" }, { text: "Blackcomb" }],
      lat: null,
      lng: null,
      accuracy: null,
      altitude: null,
      tracking: false,
      watchId: null,
      select_mountain_items: ["Both Mountains", "Whistler", "Blackcomb"],
      select_mountain_model: "Both Mountains",
      loading: true,
      search: "",
      headers: [
        {
          text: "Hydrant #",
          value: "properties.hydrnt_num"
        },
        {
          text: "Trail",
          value: "properties.trail_name"
        },
        {
          text: "30A",
          value: 'properties["30a"]'
        },
        {
          text: "60A",
          value: 'properties["60a"]'
        },
        {
          text: "Circuit",
          value: "properties.circuit"
        },
        {
          text: "Water",
          value: "properties.water"
        },
        {
          text: "Air",
          value: "properties.air"
        },
        {
          text: "Modified",
          value: "properties.modified"
        }
      ]
    };
  },
  computed: {
    computedSnowmakingHydrantGeoJsonFeatures() {
      if (
        this.$store.state.mapLayers.snowmaking.layers.hydrants.geojson.features
      ) {
        const hydrants = this.$store.state.mapLayers.snowmaking.layers.hydrants
          .geojson.features;
        switch (this.select_mountain_model) {
          case "Whistler":
            return hydrants.filter(
              item => item.properties.mountain == "Whistler"
            );
          case "Blackcomb":
            return hydrants.filter(
              item => item.properties.mountain == "Blackcomb"
            );
          case "Both Mountains":
            return hydrants;
          default:
            return hydrants;
        }
      }
      return [];
    },
    computedSnowmakingHydrantsVisibility() {
      return this.$store.state.mapLayers.snowmaking.layers.hydrants.visibility
        .listView;
    },
    computedSnowmakingHydrantsLoading() {
      return this.$store.state.mapLayers.snowmaking.layers.hydrants.loading;
    },
    computedTrails() {
      const hydrants = this.$store.state.mapLayers.snowmaking.layers.hydrants
        .geojson.features;
      const trails = [];
      hydrants.map(item => {
        trails.push(item.properties.trail_name);
      });
      const uniqueTrails = Array.from(new Set(trails));
      let finalResults = [];
      uniqueTrails.map(item => {
        finalResults.push({
          text: item
        });
      });
      return finalResults.sort((a, b) => (a.text < b.text ? -1 : 1));
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    }
  },
  methods: {
    methodDownloadCSV() {
      const fields = [
        {
          label: "Mountain",
          value: "properties.mountain"
        },
        {
          label: "Trail Name",
          value: "properties.trail_name"
        },
        {
          label: "Hydrant Number",
          value: "properties.hydrnt_num"
        },
        {
          label: "Circuit",
          value: "properties.circuit"
        },
        {
          label: "Hydrant Colour",
          value: "properties.h_colour"
        },
        {
          label: "Circuit Colour",
          value: "properties.c_colour"
        },
        {
          label: "Water",
          value: "properties.water"
        },
        {
          label: "Air",
          value: "properties.air"
        },
        {
          label: "30 Amp",
          value: "properties.30a"
        },
        {
          label: "60 Amp",
          value: "properties.60a"
        },
        {
          label: "Tower Type",
          value: "properties.tower_type"
        },
        {
          label: "Comments",
          value: "properties.notes"
        },
        {
          label: "Electrical Source",
          value: "properties.elec_maint"
        }
      ];
      const opts = { fields };

      try {
        const csv = parse(
          this.$store.state.mapLayers.snowmaking.layers.hydrants.geojson.features.sort(
            (a, b) => {
              if (a.properties.hydrnt_num < b.properties.hydrnt_num) return -1;
              if (a.properties.hydrnt_num > b.properties.hydrnt_num) return 1;
              return 0;
            }
          ),
          opts
        );
        const blob = new Blob([csv], { type: "octet/stream" });
        const a = document.createElement("a");
        document.body.appendChild(a);
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = "snowmaking_hydrants.csv";
        a.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }, 0);
      } catch (err) {
        console.error(err);
      }
    },
    geoSuccess(position) {
      this.lat = position.coords.latitude;
      this.lng = position.coords.longitude;
      this.accuracy = position.coords.accuracy;
      this.altitude = position.coords.altitude;
    },
    geoError(error) {
      console.log("geo error", error);
    },
    geoWatchPosition() {
      let geoOptions = {
        enableHighAccuracy: true,
        timeout: 30000,
        maximumAge: 0
      };
      this.tracking = true;
      this.watchId = navigator.geolocation.watchPosition(
        this.geoSuccess,
        this.geoError,
        geoOptions
      );
    },
    clearWatchLocation() {
      navigator.geolocation.clearWatch(this.watchId);
      this.tracking = false;
    },
    getNormalDate(utcdate) {
      // utc date is a string like 2018-04-16T21:52:58.811Z
      let date = new Date(utcdate);
      let y = date.getFullYear();
      let m = date.getMonth();
      let d = date.getDay();
      return y + "-" + m + "-" + d;
    },
    // method to get geojson
    methodGetSnowmakingHydrantsGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/snowmaking/hydrants",
        dept: "snowmaking",
        layer: "hydrants",
        token: this.computedAuthToken
      });
    },
    methodClearForm() {
      this.form = {
        hydrnt_num: null,
        mountain: null,
        trail_name: null,
        "30a": null,
        "60a": null,
        water: null,
        air: null,
        circuit: null,
        elec_maint: null,
        notes: null,
        edit_by: null,
        modified: null
      };
    },
    methodAddSnowmakingHydrantGeoJson(data) {
      let constFeature = {
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            geometry: {
              type: "MultiPoint",
              coordinates: [[this.lng, this.lat]]
            },
            properties: {
              hydrnt_num: data.hydrnt_num,
              mountain: data.mountain,
              trail_name: data.trail_name,
              "30a": data["30a"],
              "60a": data["60a"],
              water: data.water,
              air: data.air,
              circuit: data.circuit,
              elec_maint: data.elec_maint,
              notes: data.notes,
              edit_by: data.edit_by,
              modified: new Date(Date.now()).toISOString()
            }
          }
        ]
      };
      this.$store
        .dispatch("actionAddGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/snowmaking/hydrants",
          token: this.computedAuthToken,
          payload: constFeature
        })
        .then(() => {
          setTimeout(() => {
            this.methodGetSnowmakingHydrantsGeoJson();
          }, 250);
        });
    }
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.snowmaking.layers.hydrants.visibility.listView": function(
      newValue
    ) {
      if (newValue) {
        this.methodGetSnowmakingHydrantsGeoJson();
      }
    },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.snowmaking.layers.hydrants.geojson": function(
      newValue
    ) {
      if (newValue) {
        this.loading = false;
      }
    }
  }
};
</script>
